export function getStrategyPageLink(id: string | number) {
  return `/copy-trade/strategies/${id}`;
}
